// extracted by mini-css-extract-plugin
export var actionButton = "_ja-0";
export var fileInput = "_ja-2";
export var paperclip = "_ja-1";